<template>
  <div class="stickers-tools-items">
    <div
      v-for="item in items"
      :key="item.value"
      :class="{
        'stickers-tools-items__item': true,
        'stickers-tools-items__item--selected': item.value === value
      }"
      @click="handleChange(item.value)"
    >
      <img
        :src="item.icon"
        :class="['stickers-tools-items__icon', `stickers-tools-items__icon--${item.value}`]"
        width="58"
        height="58"
      />
      {{ item.label }}
    </div>
  </div>
</template>

<script setup>
defineProps({
  value: String,
  items: Array
});

const emit = defineEmits(["change"]);

const handleChange = item => {
  emit("change", item);
};
</script>

<style lang="scss">
@import "frontend/init/jiffy/mixin";
@import "frontend/init/jiffy/settings";

.stickers-tools-items {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  flex-wrap: wrap;
  gap: 8px;

  @include with-desktop {
    display: flex;
    gap: 16px;
  }

  &__item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    padding: 12px 16px;
    border-radius: 8px;
    border: 2px solid $gray-border;
    fill: #29abe2b2;
    color: $text-black;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.3;
    height: 112px;

    &--selected {
      font-weight: 700;
      border-color: $primary-600;
    }

    @include with-desktop {
      height: 126px;
      width: 136px;
    }
  }

  &__icon {
    width: 58px;
    height: 58px;

    @include with-desktop {
      width: 64px;
      height: 64px;
    }

    &--die-cut {
      width: 66px;
    }

    &--rectangle {
      @include with-desktop {
        width: 60px;
      }
    }

    &--oval {
      width: 56px;

      @include with-desktop {
        height: 68px;
      }
    }

    &--heart {
      @include with-desktop {
        width: 62px;
      }
    }
  }
}
</style>
